import { fetchImagemSantinhoBlobUrl } from "@/services/config";

function placeholderPorSexo(sexo) {
  return sexo === "Feminino"
    ? require("@/assets/feminino.png")
    : require("@/assets/masculino.png");
}

/**
 * Substitui img.foto por blob (GET /cliente/imagem-santinho?fileName=...) antes do toPng.
 */
export async function injectFotoPerfilParaExport(container, despedida) {
  const imgs = container.querySelectorAll("img.foto");
  if (!imgs.length) return;

  const nome = despedida?.nome_arquivo_foto_perfil;
  const sexo = despedida?.pessoa_falecida?.sexo || "Masculino";
  const fallback = placeholderPorSexo(sexo);

  for (const img of imgs) {
    img.removeAttribute("srcset");
    img.removeAttribute("crossOrigin");

    if (!nome) {
      img.src = fallback;
      continue;
    }

    try {
      const blobUrl = await fetchImagemSantinhoBlobUrl(nome);
      if (blobUrl) {
        img.src = blobUrl;
        await aguardarImg(img);
        continue;
      }
    } catch {
      /* 401, rede, etc. */
    }

    img.src = fallback;
  }
}

function aguardarImg(img) {
  return new Promise((resolve) => {
    if (img.complete) {
      resolve();
      return;
    }
    img.addEventListener("load", () => resolve(), { once: true });
    img.addEventListener("error", () => resolve(), { once: true });
  });
}
